// QR 완전 핸드오프 — 앱 미설치 착지 페이지 (전환 설계 v1.0 §7-3).
//
// 고정 딥링크 ${origin}/u/photo-upload 는 앱이 설치돼 있으면 App Links 가 가로채 앱이 열린다.
// 여기에 닿았다는 것은 앱이 없거나 App Links 검증이 안 된 상태라는 뜻이므로, 스토어로 안내한다.
//
// 인증·API 호출이 없는 공개 경로다. 라이트/다크 전환과 무관하게 고정 톤이어야 하므로 shell-* 시맨틱 대신
// 전환되지 않는 primitive 토큰(gray·indipia-purple 등)으로 그린다. tokens.css 는 shell-web main.tsx 에서 전역 로드된다
// (MobileHandoffUploadPage 와 동일 규약).

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=ai.indipia.app';

type Platform = 'android' | 'ios' | 'other';

function detectPlatform(): Platform {
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) return 'android';
  // iPadOS 13+ 는 UA 가 Macintosh 로 나와 터치 지원 여부를 함께 본다.
  if (/iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1)) return 'ios';
  return 'other';
}

export function AppInstallGuidePage() {
  const platform = detectPlatform();

  const pageStyle: React.CSSProperties = {
    minHeight: '100vh',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 20,
    padding: '32px 24px',
    background: 'var(--gray-50)',
    color: 'var(--gray-900)',
    fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, "Noto Sans KR", sans-serif',
  };

  const cardStyle: React.CSSProperties = {
    width: '100%',
    maxWidth: 420,
    boxSizing: 'border-box',
    background: 'var(--gray-0)',
    border: '1.5px solid var(--gray-200)',
    borderRadius: 16,
    padding: '32px 24px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 14,
    boxShadow: '0 6px 24px var(--alpha-black-50)',
  };

  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        <div
          style={{
            width: 56, height: 56, borderRadius: 14, background: 'var(--indipia-purple-50)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="var(--indipia-purple-600)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <rect x="5" y="2" width="14" height="20" rx="2" /><line x1="12" y1="18" x2="12.01" y2="18" />
          </svg>
        </div>

        <div style={{ fontSize: 18, fontWeight: 800, letterSpacing: '-0.5px', textAlign: 'center' }}>
          인디피아 앱에서 올릴 수 있어요
        </div>

        <div style={{ fontSize: 14, color: 'var(--gray-600)', lineHeight: 1.7, textAlign: 'center' }}>
          앱을 설치하고 로그인하면
          <br />
          휴대폰 갤러리에서 바로 사진을 올릴 수 있습니다
        </div>

        {platform === 'android' && (
          <a
            href={PLAY_STORE_URL}
            style={{
              marginTop: 6, width: '100%', boxSizing: 'border-box',
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8,
              padding: '14px 20px', borderRadius: 12,
              background: 'var(--indipia-purple-600)', color: 'var(--gray-0)',
              fontSize: 15, fontWeight: 700, textDecoration: 'none',
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Play 스토어에서 설치
          </a>
        )}

        {platform === 'ios' && (
          <div
            style={{
              marginTop: 6, width: '100%', boxSizing: 'border-box',
              padding: '14px 18px', borderRadius: 12,
              background: 'var(--gray-100)', border: '1.5px solid var(--gray-200)',
              fontSize: 13.5, color: 'var(--gray-600)', lineHeight: 1.7, textAlign: 'center',
            }}
          >
            iPhone용 앱은 준비 중입니다.
            <br />
            지금은 PC 화면에서 사진을 올려 주세요.
          </div>
        )}

        {platform === 'other' && (
          <div
            style={{
              marginTop: 6, width: '100%', boxSizing: 'border-box',
              padding: '14px 18px', borderRadius: 12,
              background: 'var(--gray-100)', border: '1.5px solid var(--gray-200)',
              fontSize: 13.5, color: 'var(--gray-600)', lineHeight: 1.7, textAlign: 'center',
            }}
          >
            휴대폰 카메라로 QR을 스캔해 주세요.
          </div>
        )}
      </div>
    </div>
  );
}
